import { toQueryString } from "./WebUtils";

const DEBUG = false;

export const ENDPOINTS = {
    // @TEMPLATE - Define the API endpoint enums here.
    getSearches: 'getSearches',
    getSearchResults: 'getSearchResults',
    postSearches: 'postSearches',
}

export const ENDPOINT_PATHS = {
    // @TEMPLATE - Define the API endpoint paths here.
    root: 'api',
    searches: 'searches',
    results: 'results',
}


export const ENDPOINT_METHODS = {
    // @TEMPLATE - Define the API endpoints here.
    getSearches: 'GET',
    getSearchResults: 'GET',
    postSearches: 'POST',
}

export const QUERYKEYS = ENDPOINTS;

// Convenience function to create the endpoint URLs for the chat API.
export const createEndpointUrl = function ({ endpoint, parameters, body }) {
    if (DEBUG) console.log(`createEndpointUrl: ${endpoint}`);
    if (DEBUG && body) console.log(parameters);
    if (DEBUG && body) console.log(body);
    switch (endpoint) {
        case ENDPOINTS.getSearches:
            var root = ENDPOINT_PATHS.root;

            if (parameters && parameters.id) {
                return `${ENDPOINT_PATHS.searches}/${parameters.id}`;
            } else {
                return `${ENDPOINT_PATHS.searches}`;
            }

        case ENDPOINTS.getSearchResults:
            if (!parameters || !parameters.id) {
                throw new Error(`Required parameter 'id' is missing for ${endpoint}`);
            }

            // Extract the URL parameters
            const {
                page,
                limit,
                sort_rule,
                sort_order
            } = parameters;

            let urlParams = toQueryString({
                page,
                limit,
                sort_rule,
                sort_order
            });

            if (urlParams == null) {
                urlParams = '';
            } else {
                urlParams = `?${urlParams}`;
            }

            var root = ENDPOINT_PATHS.root;

            return `${ENDPOINT_PATHS.searches}/${parameters.id}/${ENDPOINT_PATHS.results}${urlParams}`;
        case ENDPOINTS.postSearches:
            if (!body) {
                throw new Error(`Empty body given for ${endpoint}`);
            }

            var root = ENDPOINT_PATHS.root;

            return `${ENDPOINT_PATHS.searches}`;
        default:
            throw new Error(`Unknown endpoint: ${endpoint}`);
    }
}